module.exports = __webpack_public_path__ + "img/weddings_07_H.16c59b22.jpg";